import { withOptionsEndpoint } from "@dgs/core";
import { EventCategoryOptionResource } from "../types/eventCategory";

const baseKey = ["event-categories"];
const quickFilterKey = [...baseKey, "quick-filter"];

export const eventCategoryService = {
	...withOptionsEndpoint<EventCategoryOptionResource>(baseKey),
	quickFilterKey,
};
